import React from "react";

import { faPlay } from "@fortawesome/pro-regular-svg-icons";

import { Button } from "src/design-system/Button";
import { Callout } from "src/design-system/Callout";

export type CodeValidationResult =
  | {
      success: true;
      content: React.ReactNode;
    }
  | {
      success: false;
      message?: string;
    };

type CodeValidationActionProps = {
  dataLoc: string;
  disabled: boolean;
  loading: boolean;
  requestError: Error | null;
  result?: CodeValidationResult;
  onValidate: () => void;
};

export const CodeValidationAction: React.FC<CodeValidationActionProps> = ({
  dataLoc,
  disabled,
  loading,
  requestError,
  result,
  onValidate,
}) => (
  <div className="mt-3 flex flex-col items-start gap-2">
    <Button
      dataLoc={dataLoc}
      isDisabled={disabled}
      iconLeft={faPlay}
      isLoading={loading}
      size="sm"
      variant="secondary"
      onClick={onValidate}
    >
      Validate
    </Button>
    {!loading && requestError && (
      <Callout variant="error">Request failed: {requestError.message}</Callout>
    )}
    {!loading && !requestError && result && !result.success && (
      <Callout variant="error">{result.message ?? "Validation failed"}</Callout>
    )}
    {!loading && !requestError && result?.success && (
      <Callout variant="success">{result.content}</Callout>
    )}
  </div>
);
